import React from "react";
import dayjs from 'dayjs';
import { theme, Layout, DatePicker, Space, Table, Typography, message, Upload, Button, Modal, Form, Input } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useApiSelector } from 'src/hooks'
import { useRequest, dispatchAsync } from 'friday-async'
import { ActivityType, SendStatus } from './constants';
import jsCookie from 'js-cookie'
import config from 'src/config'
import axios from 'axios'

const { RangePicker } = DatePicker;
const { Header, Sider, Content } = Layout;
const dateFormat = 'YYYY-MM-DD';

const Goods = () => {
    const { token: { colorBgContainer }, } = theme.useToken();

    const [form] = Form.useForm();

    const apis = useApiSelector();
    const getTokenStatus = () => {
        return jsCookie.get('GOOD_TOKEN_STATUS') === "Effective"
    }
    const [tokenStatus, setToken] = React.useState(getTokenStatus())

    const [filterInfo, setFilterInfo] = React.useState({
        startTime: dayjs(),
        endTime: dayjs(),
        status: SendStatus.All,
        jobName: ActivityType.goods_20250614 as any,
    })

    const requestBody = React.useMemo(() => {
        return {
            ...filterInfo,
            isQueryReceiveResult: true,
            startTime: dayjs(filterInfo.startTime).format(dateFormat),
            endTime: dayjs(filterInfo.endTime).format(dateFormat)
        }
    }, [filterInfo])

    const { dataArray, isValidating, revalidate } = useRequest(apis.analysis.getLeads(requestBody as any))

    const onUpdateFilter = (nextValueField) => {
        setFilterInfo({
            ...filterInfo,
            ...nextValueField
        })
    }

    const deleteLead = async (_id) => {
        await dispatchAsync(apis.analysis.delete({ _id }))
        revalidate()
    }

    const uploadProps = {
        name: 'file',
        accept: '.xlsx',
        showUploadList: false,
        headers: {
            Authorization: `Bearer ${jsCookie.get('token_jwt')|| ''}`
        },
        action: `${config.host}/api/v2/activity/lead/upload?jobName=${ActivityType.goods_20250614}`,
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                revalidate()
                message.success(`${info.file.name} 文件上传成功`);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} 文件上传失败.`);
            }
        },
    };

    const download = async () => {
        const response = await axios({  
            url: `${config.host}/api/v2/activity/lead/download/template`, 
            method: 'GET',  
            responseType: 'blob'  
        })
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', '线索上传模版.xlsx'); 
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    const onOk = async () => {
        try {
            
            const vals = await form.validateFields()

            const { dataJson } = await dispatchAsync(apis.user.validate(vals))
            jsCookie.set('GOOD_TOKEN_STATUS', dataJson.key)

            if (dataJson.key === 'Invalid') {
                return message.error('密钥错误，请重试')
            }
            setToken(true);
        } catch (error) {
            message.error('系统异常')
        }
    }

    if (!tokenStatus) {
        return (
            <Modal
                title="请输入录入密钥"
                open={true}
                onOk={onOk}
                okText="确认"
            >
                <Form form={form}>
                    <Form.Item name='key' rules={[{ required: true, message: '请输入密钥' }]}>
                        <Input  placeholder="Please input your key!"/>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
    return (
        <Layout style={{ padding: '24px' }}>
          <Content
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
              background: colorBgContainer,
            }}
          >
            <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                <Typography.Title>权益商品手机号录入</Typography.Title>
                <Space>
                    线索时间：
                    <RangePicker
                        format={'YYYY-MM-DD'}
                        value={[filterInfo.startTime, filterInfo.endTime]}
                        onChange={(values) => {
                            onUpdateFilter({
                                startTime: values![0],
                                endTime: values![1],
                            })
                        }}
                    />
                    <Typography.Text>共{dataArray.length}条</Typography.Text>
                    <Button icon={<UploadOutlined  />} onClick={download}>下载线索模版</Button>
                    <Upload {...uploadProps}>
                        <Button icon={<UploadOutlined />}>上传线索</Button>
                    </Upload>
                </Space>

                <Table
                    rowKey='_id'
                    loading={isValidating}
                    columns={[
                        {
                            title: 'id',
                            dataIndex: '_id',
                            key: '_id',
                            width: 160,
                        },
                        {
                            title: '手机号',
                            dataIndex: 'tel',
                            key: 'tel',
                            width: 140,
                        },
                        {
                            title: '权益成功数',
                            dataIndex: 'receiveSuccessLenth',
                            key: 'receiveSuccessLenth',
                            width: 110,
                        },
                        {
                            title: '权益成功ID',
                            dataIndex: 'receiveSuccessCouponId',
                            key: 'receiveSuccessCouponId',
                            width: 120,
                        },
                        {
                            title: '权益失败数',
                            dataIndex: 'receiveFailLenth',
                            key: 'receiveFailLenth',
                            width:120,
                        },
                        {
                            title: '权益失败明细',
                            dataIndex: 'receiveFailComment',
                            key: 'receiveFailComment',
                            width: 160,
                        },
                        {
                            title: '创建时间',
                            dataIndex: 'createTime',
                            key: 'createTime',
                        },
                    
                        {
                            title: '操作',
                            dataIndex: 'operation',
                            key: 'oper',
                            render(val, record) {
                                const { _id } = record
                                return  (
                                    <Typography.Link onClick={() => deleteLead(_id)}>删除</Typography.Link>
                                ) 
                            }
                        },
                    ]}
                    dataSource={dataArray}
                />
            </Space>
        </Content>
        </Layout>
    )
}

export default Goods;